import { TaskQueryOptions, useTaskWithProgress } from "../hooks/useTaskWithProgress"
import { HelloResponse } from "../models/HelloResponse"
import { HelloService } from "../services/HelloService"

export interface HelloQueryParams {
  shouldError?: boolean
  waitTime?: number
}

export const useHelloQuery = (params: HelloQueryParams,options?: TaskQueryOptions) => {
  return useTaskWithProgress<HelloResponse>(
    () => {
      return HelloService.helloApiHelloGet(params.shouldError ?? false, params.waitTime ?? 0)
    },
    params,
    options
  )
}
